import React from "react";
import Header from "../../../components/molecules/Header";
import Banner from "./partials/banner";
import Item from "./partials/item";
// import { Container } from "@material-ui/core";

function INDEX() {

  // const [brandPilihan, setBrandPilihan] = useState();

  // useEffect(() => {
  //   async function getBrandPilihan() {

  //     try {
  //       const getPilihan = firefunctions.httpsCallable("getPopular");
  //       const response = await getPilihan({ find_by: 'brand' });
  //       setBrandPilihan(response.data.popular_items)
  //     } catch (e) {
  //       console.log(e)
  //     }
  //   }
  //   getBrandPilihan()
  // }, [])

  return (
    <>
      <Header type="with-search-cart" title="Kategori" />
      <Banner />
      <Item />
    </>
  );
}

export default INDEX;
